import React from "react";

import { mdiCloseCircle } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";
import { useMount } from "react-use";

import useFASTScheduleWebSocket from "../../../hooks/useFASTScheduleWebSocket";

import type { JSX } from "react";

function CalendarSchedulingModalError(): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");
  const { releaseSchedule } = useFASTScheduleWebSocket();

  useMount(() => releaseSchedule());

  return (
    <div className="flex flex-col items-center justify-center gap-[0.9375rem] p-[0.9375rem]">
      <div className="text-[1.171875rem] font-medium">
        {t("schedulingFailed")}
      </div>
      <Icon color="#D92D20" path={mdiCloseCircle} size={6.25} />
    </div>
  );
}

export default CalendarSchedulingModalError;
